import React from "react";

// Libraries
import { Grid } from "@libraries/mui";

// Molecules
import {
  DashboardWebConcretingRequest,
  DashboardWebContracts,
  DashboardWebTravels,
  LgpdDialog
} from "@molecules/index";

import { CustomerMessages } from "@languages/interfaces";
import useTranslation from "@languages/useTranslation";
import * as Styled from "./styles";

const DashboardWeb: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Styled.Container>
        <Styled.DashboardTitle>
          {t(CustomerMessages.applicationDashboard)}
        </Styled.DashboardTitle>
        <Grid container spacing={10}>
          <Grid item md={4}>
            <DashboardWebTravels />
          </Grid>
          <Grid item md={4}>
            <DashboardWebConcretingRequest />
          </Grid>
          <Grid item md={4}>
            <DashboardWebContracts />
          </Grid>
        </Grid>
      </Styled.Container>
      <LgpdDialog />
    </>
  );
};

export default DashboardWeb;
